<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :close-on-click-modal="false"
    width="460px"
    @close="handleClose"
  >
    <div v-if="!uploadSuccess">
      <p>请先<a
        href="#"
        style="color:blue"
        @click="downloadTemplate"
      >下载模板</a></p>
      <el-row>
        <el-col :span="6">选择导入文件</el-col>
        <el-col :span="18">
          <el-upload
            ref="upload"
            :action="action"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-change="handleChange"
            :before-upload="handleBeforeUpload"
            :file-list="fileList"
            :auto-upload="false"
            :multiple="false"
            :headers="headers"
            accept=".xls,.xlsx"
            name="file"
          >
            <el-button
              slot="trigger"
              size="small"
              type="primary"
            >选取文件</el-button>
            <div
              slot="tip"
              class="el-upload__tip"
            >文件大小不可超过20M，支持.xls和.xlsx格式</div>
          </el-upload>
        </el-col>
      </el-row>
      <el-row
        slot="footer"
        style="margin-top:15px;"
      >
        <el-col
          :span="18"
          :offset="6"
        >
          <span>
            <el-button
              type="primary"
              @click="submitUpload"
            >开始上传</el-button>
            <el-button @click="handleClose">取 消</el-button>
          </span>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <p>正在导入数据...</p>
      <p style="color:red">此操作为异步导入，您可在“文件存储->上传日志”中查看导入结果</p>
      <div
        slot="footer"
        style="text-align:center"
      >
        <span>
          <el-button
            type="primary"
            @click="handleClose"
          >知道了</el-button>
          <el-button @click="searchResult">查看结果</el-button>
        </span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getToken } from '@/utils/auth'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
export default {
  name: 'ImportDialog',
  props: {
    title: { type: String, default: () => '' },
    visible: { type: Boolean, default: () => false },
    action: { type: String, default: () => '' },
    fileName: { type: String, default: () => '' },
    folderName: { type: String, default: () => '' }
  },
  data() {
    return {
      fileList: [],
      uploadSuccess: false,
      headers: {
        sessionId: getToken(),
        ContentType: 'multipart/form-data'
      }
    }
  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit()
    },
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        this.fileLsit = fileList.shift()
      }
    },
    handleBeforeUpload(file) {
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isLt20M) {
        this.$message.error('文件大小不能超过20MB!')
      }
      return isLt20M
    },
    handleSuccess() {
      this.uploadSuccess = true
    },
    handleError(err) {
      console.log(err)
      this.$message.error('上传失败')
    },
    handleClose() {
      this.uploadSuccess = false
      this.$emit('onClose')
    },
    downloadTemplate() {
      ExportUtils.downloadTemplateFile(this.fileName, this.folderName)
    },
    searchResult() {
      this.$router.push({
        name: 'PriceFileManager'
      })
      this.$emit('onClose')
    }
  }
}
</script>
